import React from "react";
import "./index.scss";
import { capitalizeFirstLetter } from "../../../../utils/common";
const SubDashBreif = ({
	className = '',
	data
}) => {
	//sub-dash-breif-pic.png 
	return (
		<>
			<div className={`sub-dash-breif d-flex ${className}`}>
				<div className="pic flex-shrink-0">

					{data?.blob_name ?
						<img className='img-fluid' src={data.blob_name} alt="Office" />
						: <img className="img-fluid" src={require('../../../../assets/img/img-placeholder-detail.png')} alt="Office" />
					}

				</div>
				<div className="info">
					<h2>{data?.name && capitalizeFirstLetter(data?.name)}</h2>
					<p>
						{data?.address && capitalizeFirstLetter(data?.address)}
					</p>
				</div>
			</div>
		</>
	);

}
export default SubDashBreif;